<!-- Logo Bar - three columns: logo | title | user -->
<div class="logo-bar">
  <div class="logo-left">
    <div class="chevron-logo">
      <div class="hallmark"></div>
    </div>
  </div>

  <span class="app-title">LogMerge</span>

  <div class="user-info">
    <!-- Signed in: greeting + avatar + dropdown -->
    <ng-container *ngIf="isLoggedIn; else signInTpl">
      <button
        type="button"
        class="user-trigger"
        (click)="toggleMenu()"
        [attr.aria-expanded]="menuOpen"
        aria-haspopup="true"
      >
        <span class="user-greeting">Hello, {{ userName }}</span>
        <span class="user-avatar">{{ userInitials }}</span>
        <span class="caret" [class.open]="menuOpen">&#9662;</span>
      </button>

      <div class="user-menu" *ngIf="menuOpen" role="menu">
        <button type="button" class="user-menu-item" (click)="logout()" role="menuitem">
          Sign out
        </button>
      </div>
    </ng-container>

    <!-- Not signed in: show a Sign in button -->
    <ng-template #signInTpl>
      <button type="button" class="user-trigger" (click)="login()">
        <span class="user-greeting">Sign in</span>
      </button>
    </ng-template>
  </div>
</div>

<!-- Navigation Bar -->
<nav class="nav-bar">
  <ul class="nav-links">
    <li>
      <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Home</a>
    </li>
    <li>
      <a routerLink="/logs" routerLinkActive="active">System Logs</a>
    </li>
    <li>
      <a routerLink="/about" routerLinkActive="active">About</a>
    </li>
  </ul>
</nav>